<template>
  <MConsultationTemplateFormElement
    v-for="(item, index) in props.results"
    :key="'consultationTemplateFormElement' + index"
    :element="item"
    :form-values="formValues"
    @form-value-update="handleFormValueUpdate"
    @field-focused="(p) => emit('fieldFocused', p)"
    @field-blurred="(p) => emit('fieldBlurred', p)"
  />
</template>

<script setup lang="ts">
import MConsultationTemplateFormElement from "../MConsultationTemplateFormElement/MConsultationTemplateFormElement.vue";
import { useDebouncedThrottledFunction } from "../../../../composables/throttleDebounce";
const props = defineProps({
  results: Array,
  formValues: Object,
});

type FieldPayload = { modelValueKey: string; value: unknown } | undefined;

const emit = defineEmits<{
  (e: "formUpdatedSave", payload?: FieldPayload): void;
  (e: "fieldFocused", payload: { modelValueKey: string; value: unknown }): void;
  (e: "fieldBlurred", payload: { modelValueKey: string; value: unknown }): void;
}>();

let lastPayload: FieldPayload = undefined;

async function saveForm() {
  emit("formUpdatedSave", lastPayload);
  lastPayload = undefined;
}

function handleFormValueUpdate(payload?: FieldPayload) {
  if (payload) lastPayload = payload;
  debouncedThrottledSaveEntries();
}

const { debouncedThrottled: debouncedThrottledSaveEntries } = useDebouncedThrottledFunction(
  () => saveForm(),
  500,
  800,
);
</script>
<style>
.consultation-template-footer {
  color: var(--text-color-light);
  background: var(--medicus-background);
}
</style>
